<template>

  <svg
    t="1632672877522"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4225"
    width="64"
    height="64"
  ><path d="M960 512L512 769.9 64 512l448-257.9z" p-id="4226" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeDiamond',
} as DefineComponent
</script>